import get from 'lodash/get';

import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ShowCaseList = styled(Card)(({ theme, length }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(3),

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: `repeat(${Math.ceil(length / 2)}, 1fr)`,
  },

  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: `repeat(${length}, 1fr)`,
  },
}));

export const ShowCaseItem = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: theme.spacing(0),
  gap: theme.spacing(0),
  minHeight: 'fit-content',
}));

export const Image = styled(Stack)(({ theme, bgrColor }) => ({
  backgroundColor: bgrColor ? get(theme, bgrColor) : 'transparent',
  width: '100%',
}));

export const Content = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  width: '100%',
  backgroundColor: theme.palette.background.grey.light,
}));
